export const AI_INCIDENT_TYPES = [
  "LLM_MISUSE_TRIGGERED_UNEXPECTED_SHELL_ATTEMPT",
  "POISONED_LOG_LINE_TRIGGERED_UNAPPROVED_PRODUCTION_SHELL",
  "UNSANITIZED_PROMPT_TRIGGERED_AI_AGENT_CODE_EXECUTION",
  "PROMPT_INJECTION_WITH_SENSITIVE_OUTPUT",
  "UNSANCTIONED_NETWORK_ACCESS"
] as const
